import { createColumn, defaultColumns, inputTextField, relationField, booleanComponent } from '../_defaults/columns'
import { dateFormat } from '../../plugins/filters'

export const columns = [
  createColumn({
    label: 'Membership Type',
    field: 'membershipType',
    section: 'Data Relations',
    // description: 'Listing of all users who have access to modify this school'
    // displayValue: row => row.membershipType.description,
    // deepDisplay: row => row.description,
    ...relationField({
      validation: {
        required: true
      },
      type: 'one',
      localKey: 'membershipTypeId',
      fk: 'id',
      namespace: 'membershipType',
      // filterIs: 'text-filter',
      filterIs: 'select-one-field',
      // label: 'description'
      props: { allowEdit: false, addButton: false }
    })
  }),
  createColumn({
    label: 'Membership Period',
    field: 'membershipPeriod',
    section: 'Data Relations',
    // displayValue: 'membershipPeriod.notes',
    // displayValue: 'membershipType.description',
    displayValue: row => {
      let returnVal = ''
      if (row.membershipPeriod) {
        for (let mp of row.membershipPeriod) {
          returnVal = ''
          if (mp.registrationDate && mp.registrationDate.trim()) {
            returnVal = `(${dateFormat(mp.registrationDate, 'MMM DD YYYY')} - `
          }
          if (mp.dropDate && mp.dropDate.trim()) {
            returnVal = returnVal + `${dateFormat(mp.dropDate, 'MMM DD YYYY')})`
          } else {
            returnVal = returnVal + 'Now)'
          }
          if (mp.expiryDate && mp.expiryDate.trim()) {
            returnVal = returnVal + ` Expires: ${dateFormat(mp.expiryDate, 'MMM DD YYYY')}`
          }
          // returnVal += `(${dateFormat(mp.registrationDate, 'MMM DD YYYY')} - ${dateFormat(mp.dropDate, 'MMM DD YYYY')}) `
        }
        return returnVal
      }
    },
    // deepDisplay: row => `(${dateFormat(row.registrationDate, 'MMM DD YYYY')} - ${dateFormat(row.dropDate, 'MMM DD YYYY')}) `,
    // deepDisplay: row => {
    //   let returnVal = ''
    //   if (row.membershipPeriod) {
    //     for (let mp of row.membershipPeriod) {
    //       returnVal = ''
    //       if (mp.registrationDate && mp.registrationDate.trim()) {
    //         returnVal = `(${dateFormat(mp.registrationDate, 'MMM DD YYYY')} - `
    //       }
    //       if (mp.dropDate && mp.dropDate.trim()) {
    //         returnVal = returnVal + `${dateFormat(mp.dropDate, 'MMM DD YYYY')})`
    //       } else {
    //         returnVal = returnVal + 'Now)'
    //       }
    //       if (mp.expiryDate && mp.expiryDate.trim()) {
    //         returnVal = returnVal + ` Expires: ${dateFormat(mp.expiryDate, 'MMM DD YYYY')}`
    //       }
    //       // returnVal += `(${dateFormat(mp.registrationDate, 'MMM DD YYYY')} - ${dateFormat(mp.dropDate, 'MMM DD YYYY')}) `
    //     }
    //     return returnVal
    //   }
    // },
    ...relationField({
      type: 'many',
      fk: 'membershipId',
      localKey: 'id',
      namespace: 'membershipPeriod',
      parentRestraint: true,
      // label: 'registrationDate',
      // label: row => `(${dateFormat(row.registrationDate, 'MMM DD YYYY')} - ${dateFormat(row.dropDate, 'MMM DD YYYY')}) `,
      props: {
        showSearch: false,
        showBrowse: false,
        // filter: {
        //   path: 'membershipId',
        //   value: context => context.parentId
        // },
        config: {
          params: {}
        }
      }
    })
  }),
  createColumn({
    label: 'Year Joined',
    field: 'yearJoined',
    section: 'General Info',
    type: 'number',
    component: inputTextField({
      req: false,
      type: 'number',
      validation: {
        numeric: true,
        between: [1900, 3000]
      }
    })
  }),
  createColumn({
    label: 'Active',
    field: 'isActive',
    section: 'Status',
    defaultValue: 1,
    // description: 'School is allowed to order on weekends',
    type: 'boolean',
    // visible: false,
    component: booleanComponent
  }),
  createColumn({
    label: 'GUID',
    field: 'guidId',
    type: 'text',
    section: 'Data Info',
    filterable: false,
    visible: false,
    searchable: false,
    // defaultValue: guid,
    component: null
    // component: {
    //   req: true,
    //   props: {
    //     type: 'text',
    //     disable: true
    //   }
    // }
  }),
  createColumn({
    label: 'Approved',
    field: 'approved',
    section: 'Status',
    // description: 'School is allowed to order on weekends',
    defaultValue: 1,
    type: 'boolean',
    filterable: false,
    visible: false,
    // component: null
    component: booleanComponent
  }),
  createColumn({
    label: 'Date Approved',
    field: 'dateApproved',
    type: 'date',
    section: 'Status',
    filterable: false,
    visible: false,
    // component: null
    defaultValue: null,
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime'
        // disable: true
      }
    }
  })
  // createColumn({
  //   label: 'Company',
  //   field: 'company',
  //   section: 'Data Relations',
  //   // description: 'Listing of all users who have access to modify this school'
  //   ...relationField({
  //     props: {
  //       config: {
  //         params: {}
  //       }
  //     },
  //     validation: {
  //       required: true
  //     },
  //     isTitle: true,
  //     type: 'one',
  //     localKey: 'companyId',
  //     fk: 'id',
  //     namespace: 'company',
  //     filterIs: 'text-filter',
  //     label: 'name'
  //   })
  // }),
  // createColumn({
  //   label: 'Person',
  //   field: 'person',
  //   section: 'Data Relations',
  //   // description: 'Listing of all users who have access to modify this school'
  //   ...relationField({
  //     props: {
  //       config: {
  //         params: {}
  //       }
  //     },
  //     type: 'one',
  //     localKey: 'personId',
  //     fk: 'id',
  //     namespace: 'person',
  //     filterIs: 'text-filter',
  //     label: 'lastName'
  //   })
  // }),
  // createColumn({
  //   label: 'Suspended',
  //   field: 'isSuspended',
  //   section: 'Status',
  //   // description: 'School is allowed to order on weekends',
  //   type: 'boolean',
  //   // visible: false,
  //   component: booleanComponent
  // }),
  // createColumn({
  //   label: 'Year Joined',
  //   field: 'yearJoined',
  //   type: 'number',
  //   section: 'Data Info',
  //   component: {
  //     req: true,
  //     props: {
  //       type: 'number',
  //       maxlength: 4
  //       // disable: true
  //     },
  //     validation: {
  //       numeric: true,
  //       between: [1900, 3000]
  //     }
  //   }
  // }),
  // createColumn({
  //   label: 'Year Joined',
  //   field: 'yearJoined',
  //   type: 'number',
  //   // visible: true,
  //   // sortable: true,
  //   section: 'General Info',
  //   component: {
  //     is: 'q-select',
  //     filterIs: 'select-filter',
  //     props: {
  //       options: yearOptions.slice(0)
  //     },
  //     validation: {
  //       between: [1900, 3000],
  //       required: false
  //     }
  //   }
  // }),
].concat(defaultColumns)
